import { QUERY_KEYS } from 'api/query-keys';
import { availabilityService } from 'api/services';
import { UpdateWorkersAvailabilityDto } from 'api/services/availability/availability-service.dto';
import { DateTime } from 'luxon';
import { useMutation, useQueryClient } from 'react-query';

export const useCreateAvailability = (searchTerm: string | undefined, fromDate: DateTime) => {
  const queryClient = useQueryClient();
  const { mutateAsync: createAvailabilityMutation } = useMutation(
    async (payload: UpdateWorkersAvailabilityDto) => {
      return await availabilityService.updateWorkerAvailability(payload);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(
          QUERY_KEYS.workersAvailability(searchTerm, fromDate.toISODate())
        );
      },
    }
  );

  return { createAvailabilityMutation };
};
